import { createPortal } from 'react-dom';
import { usePDF } from '@react-pdf/renderer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTenant } from '../contexts/TenantContext';
import InvoicePDF from './InvoicePDF';
import './InvoicePreview.css';

const isOverdue = (inv) =>
  !inv.isPaid && inv.dueDate && new Date(inv.dueDate) < new Date(new Date().toDateString());

export default function InvoicePreview({ invoice, lineItems, onClose }) {
  const { tenantConfig } = useTenant();
  const companyName = tenantConfig?.tenantName || 'FMS';
  const logoUrl     = tenantConfig?.loginLogo  || null;

  const paid    = !!invoice.isPaid;
  const overdue = isOverdue(invoice);

  const [pdf] = usePDF({
    document: (
      <InvoicePDF
        invoice={invoice}
        lineItems={lineItems}
        companyName={companyName}
        logoUrl={logoUrl}
      />
    ),
  });

  const content = (
    <div className="inv-overlay">

      {/* ── Toolbar ─────────────────────────────────────────────────────────── */}
      <div className="inv-toolbar">
        <span className="inv-toolbar-title">
          Invoice {invoice.docNumber}
          {paid    && <span className="inv-toolbar-badge inv-toolbar-badge--paid">Paid</span>}
          {!paid && overdue && <span className="inv-toolbar-badge inv-toolbar-badge--overdue">Overdue</span>}
        </span>
        <div className="inv-toolbar-actions">
          <button className="inv-btn inv-btn--close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
            Close
          </button>
        </div>
      </div>

      {/* ── PDF viewer ──────────────────────────────────────────────────────── */}
      <div className="inv-pdf-wrap">
        {pdf.loading && (
          <div className="inv-pdf-status">
            <div className="inv-spinner" />
            <span>Generating PDF…</span>
          </div>
        )}
        {pdf.error && (
          <div className="inv-pdf-status inv-pdf-status--error">
            Failed to generate PDF. Please try again.
          </div>
        )}
        {pdf.url && (
          <iframe
            src={`${pdf.url}#toolbar=1&navpanes=0`}
            className="inv-pdf-frame"
            title={`Invoice ${invoice.docNumber}`}
          />
        )}
      </div>

    </div>
  );

  return createPortal(content, document.body);
}
